import { useTranslation as e } from "../../../i18n.mjs";
import { FileActionMenuDeleteItem as t, FileActionMenuDetailsItem as n, FileActionMenuDownloadItem as r, FileActionMenuRenameItem as i } from "../../../components/file-action-menu-item/index.mjs";
import { FileCard as a } from "../../../components/file-card/index.mjs";
import { isDataFileInterface as o } from "../../../types/data-file.mjs";
import { Loader as s } from "@systemeio/components";
import c, { useEffect as l, useState as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
import { useVirtualizer as p } from "@tanstack/react-virtual";
//#region src/modules/file-selector/components/file-grid.tsx
var m = 6;
function h({ initialItemWidth: h = 150, initialItemHeight: g = 180, rowGap: _ = 18, columnGap: v = 16, columnCount: y = 6, dataFilesApi: b, specialElementInGrid: x, onSelect: S, onDetails: C, onDelete: w, onRename: T, onDownload: E }) {
	let { t: D } = e(), O = c.useRef(null), k = c.useRef(null), [A, j] = u(y), [M, N] = u(h), [P, F] = u(g), [I, L] = u(), { data: R, fetchNextPage: z, hasNextPage: B, isFetchingNextPage: V, isFetching: H } = b, U = "specialElementInGridId", W = x ? A >= 2 ? [U, U] : [U] : [], G = [...W, ...R?.pages?.flatMap((e) => e.items) ?? []], K = G.length;
	l(() => {
		let e = () => {
			if (O.current) {
				let e = O.current.offsetWidth - m, t = Math.floor(e / (h + v));
				j(t || 1);
				let n = (e - v * (t - 1)) / t;
				N(n), F(n / h * g);
			}
		};
		e();
		let t = new ResizeObserver(e);
		return O.current && t.observe(O.current), () => t.disconnect();
	}, [
		h,
		g,
		v
	]);
	let q = p({
		count: Math.ceil(K / A),
		gap: _,
		getScrollElement: () => O.current,
		estimateSize: () => P
	}), J = p({
		count: A,
		gap: v,
		getScrollElement: () => O.current,
		estimateSize: () => M,
		horizontal: !0
	});
	return l(() => {
		if (!k.current || !B || V) return;
		let e = new IntersectionObserver((e) => {
			e[0]?.isIntersecting && z();
		}, {
			root: O.current,
			threshold: .1
		});
		return e.observe(k.current), () => {
			k.current && e.unobserve(k.current);
		};
	}, [
		z,
		B,
		V
	]), l(() => {
		let e = G.filter(o).find((e) => e.id === I);
		S?.(e);
	}, [I]), /* @__PURE__ */ f("div", {
		ref: O,
		className: "file-manager-scrollbar relative h-[400px] w-full overflow-auto",
		children: [/* @__PURE__ */ f("div", {
			style: {
				height: q.getTotalSize(),
				width: J.getTotalSize()
			},
			className: "relative",
			children: [H && !V ? Array.from({ length: 10 }).map((e, t) => /* @__PURE__ */ d("div", {
				className: "bg-bg-tertiary absolute animate-pulse rounded-md",
				style: {
					top: Math.floor(t / A) * (P + _),
					left: t % A * (M + v),
					height: P,
					width: M
				}
			}, t)) : q.getVirtualItems().map((e) => J.getVirtualItems().map((o) => {
				let s = e.index * A + o.index, c = G[s];
				if (!c) return null;
				let l = Math.floor(s / A) * (P + _), u = s % A * (M + v), f = 0;
				switch (A) {
					case 1:
						f = 180;
						break;
					case 2: f = 80;
				}
				return x && (l -= f), U === c ? s === 0 ? /* @__PURE__ */ d("div", {
					style: {
						top: 0,
						left: 0,
						height: P - f,
						width: M * W.length + v * (W.length - 1)
					},
					children: x
				}, c + s) : null : /* @__PURE__ */ d(a, {
					src: c.thumbnail ?? c.path ?? void 0,
					alt: c.name,
					name: c.name,
					imageWidth: M,
					imageHeight: M * .869,
					secondaryText: c.type,
					fileType: c.type,
					style: {
						top: l,
						left: u,
						height: P,
						width: M
					},
					selected: I === c.id,
					onSelect: (e) => {
						L(e ? c.id : void 0);
					},
					className: "absolute",
					actionMenu: {
						ariaLabel: `${D("file_manager.file")}: ${c.name}`,
						menuItems: [
							C && n({
								id: "details",
								onClick: () => C(c)
							}),
							T && i({
								id: "rename",
								onClick: () => T(c)
							}),
							E && r({
								id: "download",
								onClick: () => E(c)
							}),
							w && t({
								id: "delete",
								onClick: () => w(c)
							})
						].filter(Boolean)
					}
				}, c.id);
			})), B && /* @__PURE__ */ d("div", {
				ref: k,
				className: "absolute bottom-0"
			})]
		}), /* @__PURE__ */ d("div", {
			className: "flex h-11 w-full items-center justify-center pt-4",
			children: V && /* @__PURE__ */ d(s, { rootProps: { "aria-label": D("file_manager.processing_size") } })
		})]
	});
}
//#endregion
export { h as FileGrid };
